import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const FinancingPage = lazy(() => import('../pages/financing/page'));
const PaymentSuccessPage = lazy(() => import('../pages/payment-success/page'));
const RentalSuccessPage = lazy(() => import('../pages/rental-success/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const MarketplaceExportPage = lazy(() => import('../pages/marketplace-export/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/financing',
    element: <FinancingPage />,
  },
  {
    path: '/payment-success',
    element: <PaymentSuccessPage />,
  },
  {
    path: '/rental-success',
    element: <RentalSuccessPage />,
  },
  {
    path: '/admin',
    element: <AdminPage />,
  },
  {
    path: '/marketplace-export',
    element: <MarketplaceExportPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
